import { SVGProps } from 'react';

export const IconPrint = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 20 20' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.88889 2.5C6.47633 2.5 6.08067 2.67559 5.78894 2.98816C5.49722 3.30072 5.33333 3.72464 5.33333 4.16667V6.66667H14.6667V4.16667C14.6667 3.72464 14.5028 3.30072 14.2111 2.98816C13.9193 2.67559 13.5237 2.5 13.1111 2.5H6.88889ZM4.55556 8.33333C4.143 8.33333 3.74733 8.50893 3.45561 8.82149C3.16389 9.13405 3 9.55797 3 10V14.1667C3 15.0833 3.7 15.8333 4.55556 15.8333H5.33333V12.5C5.33333 12 5.64444 11.6667 6.11111 11.6667H13.8889C14.3556 11.6667 14.6667 12 14.6667 12.5V15.8333H15.4444C15.857 15.8333 16.2527 15.6577 16.5444 15.3452C16.8361 15.0326 17 14.6087 17 14.1667V10C17 9.55797 16.8361 9.13405 16.5444 8.82149C16.2527 8.50893 15.857 8.33333 15.4444 8.33333H4.55556ZM7.66667 17.5C7.46039 17.5 7.26256 17.4122 7.11669 17.2559C6.97083 17.0996 6.88889 16.8877 6.88889 16.6667V13.3333H13.1111V16.6667C13.1111 17.1667 12.8 17.5 12.3333 17.5H7.66667Z'
        fill='currentColor'
      />
    </svg>
  );
};
